import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, message, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMutation } from '@apollo/react-hooks';
import { mutations } from '../../graphql/graphql';
import _s from './index.less';

export const CustomCard = props => {
  const { item, prefix, refetch } = props;
  const [MAP_RESULT_DELETE] = useMutation(mutations.MAP_RESULT_DELETE);

  const deleteItem = () => {
    MAP_RESULT_DELETE({ variables: { id: item.id } }).then(
      res => {
        message.success('Card deleted');
        refetch();
      },
      err => {
        console.log(err);
        message.error('Error.');
      }
    );
  };

  const confirmDelete = () => {
    deleteItem();
  };

  const cancelDelete = () => {
    message.info('Deletion cancelled');
  };

  const getActions = item => {
    const actions = [
      <Link
        className={_s.viewButton}
        key={`link-view-${item.id}`}
        to={`/plan/${item.plan}/${item.id}`}
      >
        <span>View</span>
      </Link>,
      <Link className={_s.viewButton} key={`link-user-${item.id}`} to={`/user/${item.user}`}>
        <span>User</span>
      </Link>,
      <Popconfirm
        title="Are you sure to delete this result?"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        okText="Yes"
        cancelText="No"
        key={`link-result-delete-${item.id}`}
      >
        <Button type="danger" style={{ marginLeft: '10px' }}>
          Delete
        </Button>
      </Popconfirm>
    ];
    return actions;
  };

  return (
    <Card
      hoverable
      cover={item.snapshot && <img alt="" src={item.snapshot} className={_s.cardImg} />}
      actions={getActions(item)}
    >
      <Card.Meta
        title={<Link to={`/${prefix}/${item.id}`}>{item.title || item.name}</Link>}
        description={(item.map && item.map.address) || 'Address is empty'}
      />
    </Card>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

CustomCard.propTypes = {
  user: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  refetch: PropTypes.func,
  prefix: PropTypes.string
};

const connectedProfile = connect(mapStateToProps, mapDispatchToProps)(CustomCard);

export default connectedProfile;
